import React from "react";
import * as d3 from "d3";
import PropTypes from "prop-types";

import PlayingAreaNew from "../PlayingArea/index.js";

const HeatMap = ({
  averagePositionData = null,
  data = [],
  playingAreaProps = {},
  range = [
    "rgba(0, 0, 255, 0.05)",
    "rgba(255, 255, 0, 0.5)",
    "rgba(255, 0, 0, 0.5)"
  ]
}) => {
  const arrowOfDirection = {
    start: {
      x: 30,
      y: 90
    },
    end: {
      x: 70,
      y: 90
    }
  };

  return (
    <div>
      <PlayingAreaNew
        {...playingAreaProps}
        playingAreaUnderlay={({ height, isLandscape, width, x, y }) => {
          return (
            <g>
              {d3
                .contourDensity()
                .x((d) => x(parseInt(d[isLandscape ? "x" : "y"])))
                .y((d) => y(parseInt(d[isLandscape ? "y" : "x"])))
                .size([width, height])
                .bandwidth(20)(data)
                .map((contour, i) => (
                  <path
                    key={i}
                    d={d3.geoPath()(contour)}
                    fill={d3
                      .scaleLinear()
                      .domain([0, 0.001, 0.0025])
                      .range(range)(contour.value)}
                  />
                ))}
            </g>
          );
        }}
        playingAreaOverlay={({ height, isLandscape, width, x, y }) => {
          return (
            <>
              <g id="arrow-of-direction">
                <line
                  x1={x(
                    isLandscape
                      ? arrowOfDirection.start.x
                      : arrowOfDirection.start.y
                  )}
                  y1={y(
                    isLandscape
                      ? arrowOfDirection.start.y
                      : arrowOfDirection.start.x
                  )}
                  x2={x(
                    isLandscape
                      ? arrowOfDirection.end.x
                      : arrowOfDirection.end.y
                  )}
                  y2={y(
                    isLandscape
                      ? arrowOfDirection.end.y
                      : arrowOfDirection.end.x
                  )}
                  stroke="currentColor"
                  strokeWidth="4"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  markerEnd="url(#arrowhead)"
                />
              </g>
              {/* todo: make this more generic, so it's not just avg position data */}
              <g>
                {averagePositionData && (
                  <circle
                    cx={x(
                      isLandscape
                        ? averagePositionData.x
                        : averagePositionData.y
                    )}
                    cy={y(
                      isLandscape
                        ? averagePositionData.y
                        : averagePositionData.x
                    )}
                    r={25}
                    fill="red"
                  />
                )}
              </g>
            </>
          );
        }}
      />
    </div>
  );
};

HeatMap.propTypes = {
  data: PropTypes.array,
  playingAreaProps: PropTypes.object,
  range: PropTypes.array,
  x: PropTypes.func,
  y: PropTypes.func
};

export default HeatMap;
